import React, { useState, useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../lib/auth';
import LoadingSpinner from './LoadingSpinner';

interface ProtectedRouteProps {
  children: React.ReactNode;
  admin?: boolean;
}

export default function ProtectedRoute({ children, admin = false }: ProtectedRouteProps) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <LoadingSpinner fullScreen />
    );
  }
  
  if (!user) {
    // Redirect admin routes to admin login
    if (admin) {
      return <Navigate to="/auth/admin" replace />;
    }
    // Regular routes to normal login
    return <Navigate to="/auth" replace state={{ from: location }} />;
  }
  
  // Check if user is admin for admin routes
  if (admin && user.user_metadata?.role !== 'admin') {
    return <Navigate to="/auth" replace />;
  }
  
  // Redirect admin to admin dashboard if they try to access tenant routes
  if (!admin && user.user_metadata?.role === 'admin' && !location.pathname.startsWith('/admin')) {
    return <Navigate to="/admin" replace />;
  }

  return <>{children}</>;
}